import React from 'react'
import PropTypes from 'prop-types'

import { ContextHeadline, TextBlock } from '@aok/text-elements'
import { ArrowRoundedRightup, ArrowRoundedRight } from '@aok/icon-functional'
import { PrimaryButton } from '@aok/ui-elements'

import defaultProps from '../../../utils/propTypes/defaultProps'

import AllroundContainer from '../../_layouts/AllroundContainer'
import SmallContentContainer from '../../_layouts/SmallContentContainer/SmallContentContainer'

const T004 = ({ title, link, text, className }) => {
  return (
    <AllroundContainer dataTrackingName="T004">
      <div className={`flex flex-col bg-ffffff ${className}`}>
        <ContextHeadline
          text={title}
          className={`
            font-buenos-aires font-semibold text-005e3f
            text-36 leading-44
            600:text-40 600:leading-48
            1280:text-48 1280:leading-60
            ${/&shy/g.test(title) ? '' : 'hyphens'}
          `}
        />

        <SmallContentContainer isArticleContainer className="flex flex-col items-start mt-24">
          <TextBlock
            text={text}
            className="relative text-16 leading-24 font-buenos-aires-text font-regular text-293033"
          />

          {!!link && (
            <PrimaryButton url={link.url} target={link.target} className="mt-32 w-full 600:w-auto 840:mt-40">
              {link.title}
              {link.target && link.target === '_blank' ? (
                <ArrowRoundedRightup className="ml-8 w-16 h-16 fill-current" />
              ) : (
                <ArrowRoundedRight className="ml-8 w-16 h-16 fill-current" />
              )}
            </PrimaryButton>
          )}
        </SmallContentContainer>
      </div>
    </AllroundContainer>
  )
}

T004.propTypes = {
  title: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.oneOf(['_blank']),
  }),
  text: PropTypes.string,
  className: PropTypes.string,
}

T004.defaultProps = {
  title: defaultProps.TITLE,
  text: defaultProps.DESCRIPTION_RICH,
}

export default T004
